module.exports = __webpack_public_path__ + "img/full2-min.21b921d9.png";